export default __webpack_public_path__ + "static/pavle-c8d86331a80edd8e5e3ad030da98f59c.webp";